import {
  getConfiguration,
  getFlags,
} from '@foxtrotplatform/platform-micro-site-core';
import { debounce } from 'debounce';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { FlagsProvider } from 'react-feature-flags';
import { Provider } from 'react-redux';

import { App } from './App';
import { DeveloperAppConfig } from './common/config/developerAppConfig';
import reportWebVitals from './reportWebVitals';
import { saveState } from './state-management/browers-storage';
import { store } from './state-management/rootReducer';

store.subscribe(
  // we use debounce to save the state once each 800ms
  // for better performances in case multiple changes occur in a short time
  debounce(() => {
    saveState(store.getState());
  }, 800)
);

export const bootstrap = (async () => {
  const config = (await getConfiguration()) as DeveloperAppConfig;
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  const featureFlags = getFlags(config.featureFlags);

  return Promise.resolve(
    root.render(
      <React.StrictMode>
        <FlagsProvider value={featureFlags}>
          <Provider store={store}>
            <App config={config} />
          </Provider>
        </FlagsProvider>
      </React.StrictMode>
    )
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
